import { cva, type VariantProps } from 'class-variance-authority'

export const tooltipVariants = cva(
    'relative bg-foreground text-background z-[9999] w-fit max-w-xs origin-(--radix-tooltip-content-transform-origin) rounded-md px-3 py-2 text-sm text-balance',
)
export type ZardTooltipVariants = VariantProps<typeof tooltipVariants>

export const tooltipPositionVariants = cva(
    'absolute flex items-center justify-center left-1/2 -translate-x-1/2',
    {
        variants: {
            position: {
                top: 'bottom-0 translate-y-1/2',
                bottom: 'top-0 -translate-y-1/2 rotate-180',
                left: 'right-0 top-1/2 -translate-y-1/2 translate-x-1/2 rotate-270',
                right: 'left-0 top-1/2 -translate-y-1/2 -translate-x-1/2 rotate-90',
            },
        },
    },
)

export type ZardTooltipPositionVariants = NonNullable<
    VariantProps<typeof tooltipPositionVariants>['position']
>
